<template>
  <v-system-bar
    v-if="!hasVerifiedEmail"
    class="text-body-2"
    height="48"
    order="-1"
  >
    <v-container class="text-center">
      {{ t('messages.needsEmailVerification') }}
      <v-btn
        class="ml-4"
        :href="verifyLink"
        :loading="!verifyLink"
        size="small"
      >
        {{ t('messages.verify') }}
      </v-btn>
    </v-container>
  </v-system-bar>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { useVerifiedEmail } from './composables/useVerifiedEmail';

const { t } = useI18n();

const { createVerifyLink, hasVerifiedEmail } = useVerifiedEmail();

const verifyLink = ref();

onMounted(async () => {
  verifyLink.value = await createVerifyLink();
});
</script>
